import React from 'react'

import "./styles.scss"

export default function Logo() {
  return(
    <svg className="logo"
      version="1.1" x="0px" y="0px" viewBox="0 0 96.9 170"
    >
      <g>
        <g className="plus">
          <path d="M78.1,100 v37.6" strokeWidth="2.8"/>
          <path d="M59.3,118.8 h37.6" strokeWidth="2.8"/>
        </g>
        <path className="p" d="M96.9,44.7c0-5.6,0-44.7,0-44.7H0v137.6c0,0,49.7,2.6,49.5-56.6c16.1,3.5,47.4,0.1,47.4,-36.3z"/>		
        <g className="text">
          <polygon points="30.3,169.9 33.7,169.9 33.7,147.2 30.3,149.8"/>
          <polygon points="63.8,151.6 65.7,148.6 50.2,148.6 50.2,169.9 65,169.9 65,167 53.6,167 53.6,160.7 62.7,160.7 
            62.7,157.7 53.6,157.7 53.6,151.6"/>
          <path d="M88.6,161.5c4-0.4,6.6-2.9,6.6-6.5c0-3.9-3.1-6.5-7.6-6.5h-9v21.4H82v-18.4h5.4c1.3,0,4.4,0.3,4.4,3.5
            c0,3.2-3.1,3.5-4.4,3.5h-1.3l-2.4,2.5l8.6,8.9h4.5L88.6,161.5z"/>
          <path d="M9,148.6H0v21.4h3.4v-8.4v-10h5.4c1.3,0,4.4,0.3,4.4,3.5c0,3.2-3,3.5-4.4,3.5H5.9l-2.2,3H9
            c4.5,0,7.6-2.6,7.6-6.5C16.6,151.2,13.6,148.6,9,148.6z"/>
        </g>
      </g>
    </svg>
  )
}